import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'text_animation',
    label: 'Text Animation',
    type: types.BOOLEAN
  },
  {
    key: 'text',
    label: 'Text',
    type: types.TEXT
  },
  {
    key: 'cta',
    label: 'CTA',
    type: types.OBJECT,
    children: [
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT,
      },
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      }
    ]
  }
];

const defaultProps = {
  text_animation: true,
  text: 'We encourage those with high-level experience in innovative technology, EV and automotive engineering, marketing, sales, and other specialties to apply.',
  cta: {
    label: 'join our team',
    url: '/'
  }
};

export default {
  title: 'CTA Banner',
  id: 'CTABanner',
  propsSchema,
  defaultProps
};
